<template>
  <d-container fluid class="main-content-container px-4">
    <div class="page-header row no-gutters py-4">
      <div class="d-flex justify-content-between col-12">
        <div class="text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Parking types</span>
          <h3 class="page-title">Overview</h3>
        </div>
        <div class="col-3 text-right p-0">
          <d-button type="submit" @click="onAddNewParkingType" class="btn btn-primary" onclick="">Add Parking Type</d-button>
        </div>
      </div>
    </div>

    <d-card>
      <d-card-body class="p-0">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0">Parking type</th>
              </tr>
            </thead>

            <tbody>
              <template v-for="service in services">
                <tr style="cursor: pointer;" :key="service.id" @click="onServiceClick(service.id)">
                  <td style="vertical-align: middle;">{{service.localizedName}}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
export default {
  methods: {

	  onAddNewParkingType: function ($event) {
		  this.$router.push({
			  name: 'parkingtypes.create'
		  });
	  },

    onServiceClick: function ($event) {
      this.$router.push({
        params: {
          id: $event,
        },
        name: 'parkingtypes.single',
      });
    },
  },

  apollo: {
    load: function () {
      return {
        fetchPolicy: 'no-cache',
        update: function (data) {
          this.services = data.parkingTypes;
        },
        query: require('../../graphql/GetParkingTypes.gql'),
      };
    },
  },

  data: function () {
    return {
      services: [],
    };
  },
};
</script>
